var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"hamburgerMenu"}},[_c('a',{attrs:{"href":""}},[_c('b-icon-justify',{attrs:{"scale":"2.0"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }